import { AssetsService } from "app/services/AssetsService";

export const SIGNALS_LIMIT = 4;
export const SIGNALS_LIMIT_WITH_INTENT_UPSELL = SIGNALS_LIMIT - 1;
export const ICON_IMAGE_PATH = AssetsService.assetUrl("/images/intent/hot_locked.svg");
